/*
 * Pine Pup: motion and the buy flow. No libraries.
 * - reveals: one IntersectionObserver adds .is-in (CSS does the blur-rise, the ID tags dropping onto their rings
 *   and jingling, the pup peeking in, the pom-poms dropping and bouncing, the stocking swinging)
 * - nav: gathers into a frosted island once the page scrolls
 * - snow: canvas snowfall in three depths, only inside the window (paused off-screen)
 * - paw prints: the trail across a wool section walks in step with the scroll
 * - bone size chips wiggle when picked
 * - the reveal: a rAF loop (only while the section is on screen) reads scroll progress and swaps the photo, the
 *   brass ID tag and the copy per beat, dropping a pom-pom onto the garland
 * - FAQ, delivery dates (from Theme settings → Delivery), the size finder
 * - commerce: one selection (1 / 2 / 3 costumes, a colour and a size for each) shared by the buy box, the compact
 *   buy modules, the colour pick, the size finder and the sticky bar; adds mixed costumes as separate lines; the
 *   "Your stocking" drawer (steppers, bundle saving from the cart's real discounts, make-it-a-pair nudge, opt-in
 *   shipping protection); CTAs scroll to the nearest buy module
 * Decorative scripts (snow in the window, the paw walk, the reveal, parallax) start when the page is idle.
 * Reduced motion: no snow, the reveal is a static list.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var $ = function (sel, el) {
    return (el || document).querySelector(sel);
  };
  var $$ = function (sel, el) {
    return Array.prototype.slice.call((el || document).querySelectorAll(sel));
  };
  var clamp = function (v, a, b) {
    return Math.min(b, Math.max(a, v));
  };

  /* ───────── reveals ───────── */
  function reveals() {
    var els = $$('[data-reveal], [data-swing], [data-jingle], [data-peek], [data-poms], [data-reveal-class], [data-final]');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ───────── nav island ───────── */
  function nav() {
    var s = document.createElement('div');
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:90px;pointer-events:none;';
    document.body.prepend(s);
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      root.classList.toggle('is-scrolled', !e[0].isIntersecting);
    }).observe(s);
  }

  /* ───────── hero drift (parallax while the hero is on screen) ───────── */
  function drift() {
    var el = $('[data-drift]');
    var hero = $('[data-hero]');
    if (!el || !hero || reduced) return;
    var on = true;
    var raf = 0;
    function loop() {
      var y = window.scrollY;
      el.style.transform = 'translate3d(0,' + (y * 0.16).toFixed(1) + 'px,0)';
      raf = on ? requestAnimationFrame(loop) : 0;
    }
    new IntersectionObserver(function (e) {
      on = e[0].isIntersecting;
      if (on && !raf) raf = requestAnimationFrame(loop);
    }).observe(hero);
  }

  /* ───────── snowfall ───────── */
  function snow() {
    if (reduced) return;
    var sprite = document.createElement('canvas');
    sprite.width = sprite.height = 64;
    var sc = sprite.getContext('2d');
    var g = sc.createRadialGradient(32, 32, 0, 32, 32, 32);
    g.addColorStop(0, 'rgba(255,255,255,1)');
    g.addColorStop(0.35, 'rgba(255,255,255,0.85)');
    g.addColorStop(0.7, 'rgba(255,255,255,0.22)');
    g.addColorStop(1, 'rgba(255,255,255,0)');
    sc.fillStyle = g;
    sc.fillRect(0, 0, 64, 64);

    $$('canvas[data-snow]').forEach(function (cv) {
      var density = parseFloat(cv.getAttribute('data-snow')) || 1;
      var ctx = cv.getContext('2d');
      var W = 0;
      var H = 0;
      var dpr = 1;
      var flakes = [];
      var on = false;
      var raf = 0;
      var t = 0;

      function make(layer, spawnTop) {
        var f = { layer: layer };
        if (layer === 0) {
          f.r = 0.7 + Math.random() * 1.1;
          f.vy = 0.35 + Math.random() * 0.35;
          f.a = 0.45 + Math.random() * 0.4;
          f.amp = 0.25;
        } else if (layer === 1) {
          f.r = 1.6 + Math.random() * 1.6;
          f.vy = 0.75 + Math.random() * 0.5;
          f.a = 0.55 + Math.random() * 0.35;
          f.amp = 0.5;
        } else {
          f.r = 7 + Math.random() * 9;
          f.vy = 1.5 + Math.random() * 1;
          f.a = 0.1 + Math.random() * 0.16;
          f.amp = 0.9;
        }
        f.x = Math.random() * W;
        f.y = spawnTop ? -f.r * 4 - Math.random() * 40 : Math.random() * H;
        f.ph = Math.random() * Math.PI * 2;
        f.fr = 0.006 + Math.random() * 0.01;
        return f;
      }
      function size() {
        var r = cv.getBoundingClientRect();
        dpr = Math.min(1.5, window.devicePixelRatio || 1);
        W = r.width;
        H = r.height;
        cv.width = Math.round(W * dpr);
        cv.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var area = W * H;
        var counts = [Math.round((area / 7000) * density), Math.round((area / 22000) * density), Math.round((area / 140000) * density)];
        flakes = [];
        counts.forEach(function (c, layer) {
          for (var i = 0; i < c; i++) flakes.push(make(layer, false));
        });
      }
      function frame() {
        t += 1;
        ctx.clearRect(0, 0, W, H);
        var wind = Math.sin(t * 0.002) * 0.25 + 0.15;
        for (var i = 0; i < flakes.length; i++) {
          var f = flakes[i];
          f.y += f.vy;
          f.x += Math.sin(t * f.fr + f.ph) * f.amp + wind * (f.layer + 0.5) * 0.6;
          if (f.y > H + f.r * 4 || f.x < -40 || f.x > W + 40) {
            flakes[i] = make(f.layer, true);
            continue;
          }
          var d = f.r * (f.layer === 2 ? 2.4 : 2);
          ctx.globalAlpha = f.a;
          ctx.drawImage(sprite, f.x - d / 2, f.y - d / 2, d, d);
        }
        ctx.globalAlpha = 1;
        raf = on && !document.hidden ? requestAnimationFrame(frame) : 0;
      }
      function start() {
        if (on && !raf && !document.hidden) raf = requestAnimationFrame(frame);
      }
      size();
      var lastW = window.innerWidth;
      window.addEventListener('resize', function () {
        if (Math.abs(window.innerWidth - lastW) < 40 && flakes.length) return;
        lastW = window.innerWidth;
        size();
      });
      document.addEventListener('visibilitychange', start);
      new IntersectionObserver(function (e) {
        on = e[0].isIntersecting;
        if (on) {
          if (!W) size();
          start();
        }
      }).observe(cv);
    });
  }

  /* ───────── paw prints: the walk follows the scroll ───────── */
  function walk() {
    var trails = $$('[data-paws]');
    if (!trails.length) return;
    var items = trails.map(function (t) {
      return { el: t, host: t.parentElement, paws: $$('.paw', t), on: false };
    });
    if (reduced) {
      items.forEach(function (it) {
        it.paws.forEach(function (p) {
          p.classList.add('is-down');
        });
      });
      return;
    }
    var raf = 0;
    function frame() {
      raf = 0;
      var vh = window.innerHeight;
      items.forEach(function (it) {
        if (!it.on) return;
        var r = it.host.getBoundingClientRect();
        // starts as the section's top reaches 85% of the screen, the last print lands as its bottom reaches 55%
        var p = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.3), 0, 1);
        var n = it.paws.length;
        it.paws.forEach(function (paw, i) {
          paw.classList.toggle('is-down', i < Math.round(p * n * 1.15));
        });
      });
    }
    function ask() {
      if (!raf) raf = requestAnimationFrame(frame);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        items.forEach(function (it) {
          if (it.host === e.target) it.on = e.isIntersecting;
        });
      });
      ask();
    });
    items.forEach(function (it) {
      io.observe(it.host);
    });
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
  }

  /* ───────── bone size chips wiggle when picked ───────── */
  function wiggle() {
    if (reduced) return;
    document.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || !r.matches || !r.matches('input[data-opt="s"]')) return;
      var bone = r.nextElementSibling;
      if (!bone || !bone.classList.contains('bone')) return;
      bone.classList.remove('is-wiggle');
      void bone.offsetWidth;
      bone.classList.add('is-wiggle');
      bone.addEventListener(
        'animationend',
        function () {
          bone.classList.remove('is-wiggle');
        },
        { once: true }
      );
    });
  }

  /* ───────── the reveal (pinned photo story) ───────── */
  function story() {
    var el = $('[data-story]');
    if (!el) return;
    var beats = $$('[data-beat-copy]', el);
    var photos = $$('[data-ph]', el);
    var tags = $$('[data-beat-tag]', el);
    var rails = $$('[data-rail]', el);
    var count = $('[data-count]', el);
    var N = beats.length;
    if (!N) return;

    var beat = -1;
    var target = 0;
    var cur = -1;
    var on = false;
    var raf = 0;
    var outT = [];

    function setBeat(b) {
      if (b === beat) return;
      beat = b;
      [beats, photos, tags].forEach(function (list, li) {
        list.forEach(function (node, k) {
          if (k === b) {
            node.classList.remove('is-out');
            node.classList.add('is-on');
          } else if (node.classList.contains('is-on')) {
            node.classList.remove('is-on');
            if (li !== 1) {
              node.classList.add('is-out');
              clearTimeout(outT[li * 10 + k]);
              outT[li * 10 + k] = setTimeout(function () {
                node.classList.remove('is-out');
              }, 750);
            }
          }
        });
      });
      // a pom-pom drops onto the garland for each beat reached
      rails.forEach(function (r, k) {
        r.classList.toggle('is-on', k <= b);
        r.classList.toggle('is-cur', k === b);
      });
      if (count) count.textContent = String(b + 1);
    }

    function progress() {
      var r = el.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      return span > 0 ? clamp(-r.top / span, 0, 1) : 0;
    }

    function loop() {
      target = progress();
      if (cur < 0) cur = target;
      cur += (target - cur) * 0.16;
      if (Math.abs(target - cur) < 0.0005) cur = target;
      el.style.setProperty('--p', cur.toFixed(4));
      setBeat(Math.min(N - 1, Math.floor(cur * N * 0.9999)));
      raf = on ? requestAnimationFrame(loop) : 0;
    }

    if (reduced) {
      el.classList.add('is-static');
      beats.forEach(function (b) {
        b.classList.add('is-on');
      });
      rails.forEach(function (r) {
        r.classList.add('is-on');
      });
      return;
    }

    setBeat(0);
    new IntersectionObserver(function (e) {
      on = e[0].isIntersecting;
      if (on && !raf) raf = requestAnimationFrame(loop);
    }).observe(el);
  }

  /* ───────── FAQ ───────── */
  function faq() {
    $$('.qa__q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.setAttribute('aria-expanded', q.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });
  }

  /* ───────── delivery dates: "N" calendar days, "Nb" business days, or a range "A-B" / "Ab-Bb" ───────── */
  function dates() {
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' });
    } catch (e) {
      return;
    }
    function at(raw) {
      var n = parseInt(raw, 10);
      var d = new Date();
      if (/b$/.test(raw)) {
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) n--;
        }
        return d;
      }
      d.setDate(d.getDate() + n);
      return d;
    }
    $$('[data-date]').forEach(function (el) {
      var parts = el.getAttribute('data-date').split('-');
      if (parts.length === 1) {
        el.textContent = fmt.format(at(parts[0]));
        return;
      }
      var a = at(parts[0]);
      var b = at(parts[1]);
      el.textContent = a.getMonth() === b.getMonth() ? fmt.format(a) + '–' + b.getDate() : fmt.format(a) + ' – ' + fmt.format(b);
    });
  }

  /* ───────── commerce: one selection shared by every buy module ───────── */
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(s, map) {
    return String(s || '').replace(/%(kg|lb|s)/g, function (m, k) {
      return map[k] == null ? m : map[k];
    });
  }

  var D = null;
  function data() {
    if (D) return D;
    var el = $('#pp-data');
    if (!el) return null;
    try {
      D = JSON.parse(el.textContent);
    } catch (e) {
      D = null;
    }
    return D;
  }

  function commerce() {
    if (!data()) return;
    var T = D.text || {};
    var V = D.variants || [];
    if (!V.length) return;
    var C = D.colours || [];
    var SZ = D.sizes || [];
    var byId = {};
    V.forEach(function (v) {
      byId[v.id] = v;
    });
    function colourName(raw) {
      raw = String(raw || '').trim().toLowerCase();
      for (var i = 0; i < C.length; i++) if (C[i].name.toLowerCase() === raw) return C[i].name;
      return C.length ? C[0].name : V[0].c;
    }
    function colourOf(name) {
      for (var i = 0; i < C.length; i++) if (C[i].name === name) return C[i];
      return C[0] || { name: name, key: String(name).toLowerCase(), img: '' };
    }
    function variantFor(u) {
      var hit = null;
      V.forEach(function (v) {
        if (!hit && v.c === u.c && (v.s === u.s || !v.s)) hit = v;
      });
      return hit || V[0];
    }
    var unit = V[0].price;
    var compareAt = V[0].compare;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var main = $('[data-buy-module="main"]');
    var mainForm = main ? $('form[action*="/cart/add"]', main) : null;

    function offFor(q) {
      var off = 0;
      (D.tiers || []).forEach(function (t) {
        if (q >= t.qty) off = t.off;
      });
      return off;
    }

    /* the shared selection */
    var startQty = D.defaultQty || 1;
    var checkedTier = main ? $('input[name="quantity"][data-qty]:checked', main) : null;
    if (checkedTier) startQty = Number(checkedTier.getAttribute('data-qty'));
    var startSize = SZ.indexOf(D.defaultSize) >= 0 ? D.defaultSize : SZ[Math.floor(SZ.length / 2)] || '';
    var S = { qty: startQty, units: [], colour: null };
    for (var i = 0; i < 3; i++) S.units.push({ c: colourName((D.defaultColours || [])[i] || (C[i % (C.length || 1)] || {}).name), s: startSize });
    S.colour = S.units[0].c;

    function chosen() {
      return S.units.slice(0, S.qty);
    }
    function isMixed() {
      var c = chosen();
      var first = variantFor(c[0]).id;
      return c.some(function (u) {
        return variantFor(u).id !== first;
      });
    }
    function totals() {
      var line = unit * S.qty;
      // the same rounding as Shopify's automatic discounts: the per-unit discount is rounded down
      var total = S.qty * (unit - Math.floor((unit * offFor(S.qty)) / 100));
      var was = S.qty > 1 ? line : compareAt;
      return { total: total, was: was };
    }
    function items() {
      var m = {};
      var order = [];
      chosen().forEach(function (u) {
        var id = variantFor(u).id;
        if (!m[id]) order.push(id);
        m[id] = (m[id] || 0) + 1;
      });
      return order.map(function (id) {
        return { id: id, quantity: m[id] };
      });
    }
    function summary() {
      var parts = [];
      var seen = {};
      chosen().forEach(function (u) {
        var k = u.c + (u.s ? ' ' + u.s : '');
        if (seen[k]) seen[k].n++;
        else {
          seen[k] = { k: k, n: 1 };
          parts.push(seen[k]);
        }
      });
      return parts
        .map(function (p) {
          return (p.n > 1 ? p.n + ' × ' : '') + p.k;
        })
        .join(' + ');
    }
    function setQty(q) {
      q = clamp(q, 1, 3);
      for (var i = S.qty; i < q; i++) {
        // a new costume takes the next colour (the pair starts green + red) and the size before it
        var prev = S.units[i - 1];
        var idx = 0;
        for (var j = 0; j < C.length; j++) if (C[j].name === prev.c) idx = j;
        S.units[i] = { c: C.length ? C[(idx + 1) % C.length].name : prev.c, s: prev.s };
      }
      S.qty = q;
    }

    var subs = [];
    function emit() {
      subs.forEach(function (f) {
        f();
      });
    }

    /* paint every bound element */
    function paint() {
      var t = totals();
      var sum = summary();
      var key = colourOf(S.colour).key;
      $$('[data-sel-summary]').forEach(function (el) {
        el.textContent = sum;
      });
      $$('[data-sel-qty]').forEach(function (el) {
        el.textContent = S.qty + ' ' + (S.qty > 1 ? T.many : T.one);
      });
      $$('[data-sel-total]').forEach(function (el) {
        el.textContent = money(t.total);
      });
      $$('[data-sel-was]').forEach(function (el) {
        el.textContent = money(t.was);
        el.hidden = !(t.was > t.total);
      });
      $$('[data-sel-unit]').forEach(function (el) {
        el.textContent = money(unit);
      });
      $$('[data-sel-img]').forEach(function (el) {
        var src = colourOf(S.colour).img;
        if (src && el.getAttribute('src') !== src) el.setAttribute('src', src);
      });
      $$('[data-qty-pick]').forEach(function (b) {
        b.setAttribute('aria-pressed', Number(b.getAttribute('data-qty-pick')) === S.qty ? 'true' : 'false');
      });
      $$('[data-unit-row]').forEach(function (row) {
        row.hidden = Number(row.getAttribute('data-unit-row')) >= S.qty;
      });
      $$('input[data-unit][data-opt]').forEach(function (r) {
        var u = S.units[Number(r.getAttribute('data-unit'))];
        r.checked = !!u && u[r.getAttribute('data-opt')] === r.value;
      });
      $$('[data-colour-all]').forEach(function (b) {
        var v = b.getAttribute('data-colour-all');
        b.setAttribute(
          'aria-pressed',
          chosen().every(function (u) {
            return u.c === v;
          })
            ? 'true'
            : 'false'
        );
      });
      // compact modules show the photo of the colour picked last
      $$('.mini__photo').forEach(function (ph) {
        var imgs = $$('img[data-colour-img]', ph);
        var has = imgs.some(function (im) {
          return im.getAttribute('data-colour-img') === key;
        });
        imgs.forEach(function (im, k) {
          var onNow = has ? im.getAttribute('data-colour-img') === key : k === 0;
          if (onNow) im.loading = 'eager';
          im.classList.toggle('is-on', onNow);
        });
      });
      if (main) {
        $$('input[name="quantity"][data-qty]', main).forEach(function (r) {
          r.checked = Number(r.getAttribute('data-qty')) === S.qty;
        });
        var idIn = $('[data-variant-id]', main);
        if (idIn) idIn.value = variantFor(chosen()[0]).id;
        var express = $('[data-express]', main);
        var note = $('[data-mixed-note]', main);
        if (express) express.classList.toggle('is-hidden', isMixed());
        if (note) note.hidden = !isMixed();
      }
    }
    subs.push(paint);

    /* main gallery: thumbs, and picking a colour shows it */
    var gimgs = main ? $$('.gal__main img', main) : [];
    var thumbs = main ? $$('[data-gal-thumb]', main) : [];
    function show(k) {
      if (k > 0) root.classList.add('gal-ready');
      gimgs.forEach(function (im, j) {
        if (j === k) im.loading = 'eager';
        im.classList.toggle('is-on', j === k);
      });
      thumbs.forEach(function (x, j) {
        x.setAttribute('aria-current', j === k ? 'true' : 'false');
      });
    }
    if (gimgs.length) show(0);
    var galReady = function () {
      root.classList.add('gal-ready');
    };
    if (document.readyState === 'complete') idle(galReady);
    else
      window.addEventListener('load', function () {
        idle(galReady);
      });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        show(k);
      });
    });
    function showColour(name) {
      var key = colourOf(name).key;
      for (var i = 0; i < gimgs.length; i++) {
        if (gimgs[i].getAttribute('data-colour-img') === key) return show(i);
      }
    }

    /* inputs */
    document.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || !r.matches) return;
      if (r.matches('input[data-unit][data-opt]') && r.checked) {
        var u = S.units[Number(r.getAttribute('data-unit'))];
        if (!u) return;
        u[r.getAttribute('data-opt')] = r.value;
        if (r.getAttribute('data-opt') === 'c') {
          S.colour = r.value;
          showColour(r.value);
        }
        emit();
      } else if (main && main.contains(r) && r.matches('input[name="quantity"][data-qty]') && r.checked) {
        setQty(Number(r.getAttribute('data-qty')));
        emit();
      }
    });
    document.addEventListener('pp:size-all', function (e) {
      var s = e.detail && e.detail.size;
      if (SZ.indexOf(s) < 0) return;
      S.units.forEach(function (u) {
        u.s = s;
      });
      emit();
    });
    document.addEventListener('click', function (e) {
      var qp = e.target.closest('[data-qty-pick]');
      if (qp) {
        setQty(Number(qp.getAttribute('data-qty-pick')));
        emit();
        return;
      }
      var ca = e.target.closest('[data-colour-all]');
      if (ca) {
        var v = colourName(ca.getAttribute('data-colour-all'));
        S.units.forEach(function (u) {
          u.c = v;
        });
        S.colour = v;
        showColour(v);
        emit();
        return;
      }
      var pr = e.target.closest('[data-pair]');
      if (pr) {
        S.qty = 1;
        S.units[0].c = C[0] ? C[0].name : S.units[0].c;
        setQty(2);
        S.colour = S.units[0].c;
        emit();
        toModuleAfter(pr);
        return;
      }
      var add = e.target.closest('[data-add-sel]');
      if (add) {
        addSelection(add);
        return;
      }
      var cta = e.target.closest('[data-cta]');
      if (cta) {
        e.preventDefault();
        toNearestModule();
      }
    });

    /* cart requests */
    function post(url, body) {
      return fetch(base + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      });
    }
    function addSelection(btn) {
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      var msg = main ? $('[data-msg]', main) : null;
      if (msg) {
        msg.textContent = '';
        msg.classList.remove('is-err');
      }
      return post('cart/add.js', { items: items() })
        .then(function () {
          return drawer.open();
        })
        .catch(function (err) {
          var text = (err && (err.description || err.message)) || T.error;
          if (msg && main.contains(btn)) {
            msg.textContent = text;
            msg.classList.add('is-err');
          } else {
            window.alert(text);
          }
        })
        .then(function () {
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
    }
    if (mainForm) {
      mainForm.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        addSelection($('[data-add]', mainForm));
      });
    }

    function scrollToModule(m) {
      var isMain = m.getAttribute('data-buy-module') === 'main';
      var target = isMain ? $('.buy__panel', m) || m : $('.mini__card', m) || m;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: isMain ? 'start' : 'center' });
    }
    function toNearestModule() {
      var mods = $$('[data-buy-module]');
      if (!mods.length) return;
      var best = mods[0];
      var bestD = Infinity;
      mods.forEach(function (m) {
        var r = m.getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - window.innerHeight / 2);
        if (d < bestD) {
          bestD = d;
          best = m;
        }
      });
      scrollToModule(best);
    }
    function toModuleAfter(el) {
      var mods = $$('[data-buy-module]');
      for (var i = 0; i < mods.length; i++) {
        if (el.compareDocumentPosition(mods[i]) & Node.DOCUMENT_POSITION_FOLLOWING) return scrollToModule(mods[i]);
      }
      toNearestModule();
    }

    /* ── the drawer: Your stocking ── */
    var drawer = (function () {
      var el = $('[data-drawer]');
      if (!el) {
        return {
          open: function () {
            window.location.href = base + 'cart';
          },
          refresh: function () {}
        };
      }
      var panel = $('.drawer__panel', el);
      var linesEl = $('[data-lines]', el);
      var empty = $('[data-empty]', el);
      var foot = $('[data-foot]', el);
      var nudge = $('[data-nudge]', el);
      var prot = $('[data-protect]', el);
      var protWrap = $('[data-protect-wrap]', el);
      var P = D.protection;
      var cart = null;
      var lastFocus = null;
      var isOpen = false;
      if (P && $('[data-protect-price]', el)) $('[data-protect-price]', el).textContent = money(P.price);

      function isOurs(it) {
        return !!byId[it.variant_id];
      }
      function protItem() {
        return P && cart
          ? cart.items.filter(function (it) {
              return it.variant_id === P.id;
            })[0]
          : null;
      }
      function ourCount() {
        return cart
          ? cart.items.filter(isOurs).reduce(function (n, it) {
              return n + it.quantity;
            }, 0)
          : 0;
      }
      function refresh() {
        return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(function (c) {
            cart = c;
            return tidy();
          })
          .then(render);
      }
      /* protection never outlives the costumes, and is never more than one */
      function tidy() {
        var p = protItem();
        if (!p) return Promise.resolve();
        var n = ourCount();
        if (!n || p.quantity > 1) {
          return post('cart/change.js', { id: p.key, quantity: n ? 1 : 0 }).then(function (c) {
            cart = c;
          });
        }
        return Promise.resolve();
      }
      function render() {
        if (!cart) return;
        var n = ourCount();
        var p = protItem();
        var ours = cart.items.filter(isOurs);
        linesEl.innerHTML = ours
          .map(function (it) {
            var v = byId[it.variant_id];
            var img = (v && colourOf(v.c).img) || it.image || '';
            var struck = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
            return (
              '<li class="line-item">' +
              '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' +
              '<p class="line-item__t"><b>' + esc(it.product_title) + '</b><span>' + esc(it.variant_title || '') + '</span></p>' +
              '<div class="line-item__p"><b>' + money(it.final_line_price) + '</b>' + struck +
              '<span class="step"><button type="button" data-step="-1" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '" aria-label="' + esc(T.decrease) + '">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-step="1" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '" aria-label="' + esc(T.increase) + '">+</button></span></div>' +
              '</li>'
            );
          })
          .join('');
        empty.hidden = n > 0;
        foot.hidden = n === 0;
        nudge.hidden = n !== 1;
        if (protWrap) protWrap.hidden = !P || n === 0;
        if (prot) prot.checked = !!p;
        var original = ours.reduce(function (s, it) {
          return s + it.original_line_price;
        }, 0);
        var saving = ours.reduce(function (s, it) {
          return s + (it.original_line_price - it.final_line_price);
        }, 0);
        $('[data-t-original]', el).textContent = money(original);
        $('[data-t-save-row]', el).hidden = saving <= 0;
        $('[data-t-save]', el).textContent = '−' + money(saving);
        var protRow = $('[data-t-prot-row]', el);
        if (protRow) {
          protRow.hidden = !p;
          if (p) $('[data-t-prot]', el).textContent = money(p.final_line_price);
        }
        $('[data-t-total]', el).textContent = money(cart.total_price);
        var count = $('[data-cart-count]');
        if (count) {
          count.textContent = n;
          count.hidden = !n;
        }
      }
      function change(key, q) {
        el.setAttribute('aria-busy', 'true');
        return post('cart/change.js', { id: key, quantity: q })
          .then(function (c) {
            cart = c;
            return tidy();
          })
          .then(render)
          .catch(function () {
            return refresh();
          })
          .then(function () {
            el.removeAttribute('aria-busy');
          });
      }
      linesEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-step]');
        if (!b) return;
        var q = Number(b.getAttribute('data-q')) + Number(b.getAttribute('data-step'));
        change(b.getAttribute('data-key'), Math.max(0, q));
      });
      if (nudge) {
        $('[data-nudge-add]', nudge).addEventListener('click', function () {
          // make it a pair: the other colour, the same size
          var one = cart && cart.items.filter(isOurs)[0];
          if (!one) return;
          var v = byId[one.variant_id];
          var other = null;
          V.forEach(function (x) {
            if (!other && x.c !== v.c && x.s === v.s && x.available) other = x;
          });
          el.setAttribute('aria-busy', 'true');
          post('cart/add.js', { items: [{ id: (other || v).id, quantity: 1 }] })
            .then(refresh)
            .then(function () {
              el.removeAttribute('aria-busy');
            });
        });
      }
      if (prot && P) {
        prot.addEventListener('change', function () {
          var p = protItem();
          el.setAttribute('aria-busy', 'true');
          var req = prot.checked
            ? p
              ? Promise.resolve()
              : post('cart/add.js', { items: [{ id: P.id, quantity: 1 }] })
            : p
              ? post('cart/change.js', { id: p.key, quantity: 0 })
              : Promise.resolve();
          req.then(refresh).then(function () {
            el.removeAttribute('aria-busy');
          });
        });
      }
      function open() {
        lastFocus = document.activeElement;
        el.hidden = false;
        isOpen = true;
        root.classList.add('is-drawer-open');
        updateBar();
        requestAnimationFrame(function () {
          el.classList.add('is-open');
          panel.focus({ preventScroll: true });
        });
        return refresh();
      }
      function close() {
        if (!isOpen) return;
        isOpen = false;
        el.classList.remove('is-open');
        root.classList.remove('is-drawer-open');
        updateBar();
        setTimeout(function () {
          if (!isOpen) el.hidden = true;
        }, 650);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      $$('[data-drawer-close]', el).forEach(function (b) {
        b.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (!isOpen) return;
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') {
          var f = $$('button, [href], input, [tabindex]:not([tabindex="-1"])', panel).filter(function (x) {
            return x.offsetParent !== null && !x.disabled;
          });
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) {
            e.preventDefault();
            f[f.length - 1].focus();
          } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
            e.preventDefault();
            f[0].focus();
          }
        }
      });
      $$('.nav__cart').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          open();
        });
      });
      return {
        open: open,
        close: close,
        refresh: refresh,
        isOpen: function () {
          return isOpen;
        }
      };
    })();

    /* ── the sticky bar ── */
    var bar = $('[data-sbar]');
    var vis = new Map();
    var passed = false;
    function updateBar() {
      if (!bar) return;
      var any = false;
      vis.forEach(function (v) {
        if (v) any = true;
      });
      var on = passed && !any && !(drawer.isOpen && drawer.isOpen());
      bar.classList.toggle('is-on', on);
      root.classList.toggle('has-sbar', on);
    }
    if (bar && 'IntersectionObserver' in window) {
      var watched = $$('[data-buy-module]');
      var fin = $('[data-final]');
      if (fin) watched.push(fin);
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            vis.set(e.target, e.isIntersecting);
            if (e.target === main) passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          });
          if (!main) passed = window.scrollY > window.innerHeight;
          updateBar();
        },
        { rootMargin: '-12% 0px -12% 0px' }
      );
      watched.forEach(function (w) {
        io.observe(w);
      });
    }

    emit();
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        var n = c.items.filter(function (it) {
          return !!byId[it.variant_id];
        }).reduce(function (s, it) {
          return s + it.quantity;
        }, 0);
        var count = $('[data-cart-count]');
        if (count) {
          count.textContent = n;
          count.hidden = !n;
        }
      })
      .catch(function () {});
  }

  /* ───────── the size finder: weight → size, from Theme settings → Sizes ───────── */
  function finder() {
    var F = $$('[data-finder]');
    if (!F.length || !data()) return;
    var T = D.text || {};
    var KG_LB = 2.20462;
    var bands = [];
    (D.sizes || []).forEach(function (s) {
      var g = (D.guide || {})[s] || {};
      var m = String(g.kg || '').match(/([\d.]+)\s*[–-]\s*([\d.]+)/);
      if (m) bands.push({ s: s, lo: parseFloat(m[1]), hi: parseFloat(m[2]), kg: g.kg, lb: g.lb });
    });
    if (!bands.length) return;
    var unitPref = 'kg';
    F.forEach(function (f) {
      var range = $('[data-finder-w]', f);
      var val = $('[data-finder-val]', f);
      var out = $('[data-finder-out]', f);
      var use = $('[data-finder-use]', f);
      var useLabel = $('[data-finder-use-label]', f);
      var unitBtns = $$('[data-finder-unit]', f);
      var size = null;
      var kg = 3.5;
      function setUnit(u) {
        unitPref = u;
        unitBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-finder-unit') === u ? 'true' : 'false');
        });
        if (u === 'lb') {
          range.min = 2;
          range.max = 20;
          range.step = 0.5;
          range.value = (kg * KG_LB).toFixed(1);
        } else {
          range.min = 1;
          range.max = 9;
          range.step = 0.1;
          range.value = kg.toFixed(1);
        }
        update();
      }
      function placeBands() {
        var mn = parseFloat(range.min);
        var mx = parseFloat(range.max);
        var k = unitPref === 'lb' ? KG_LB : 1;
        $$('[data-finder-band]', f).forEach(function (li) {
          var b = null;
          bands.forEach(function (x) {
            if (x.s === li.getAttribute('data-finder-band')) b = x;
          });
          if (!b) return;
          var a = ((b.lo * k - mn) / (mx - mn)) * 100;
          var z = ((b.hi * k - mn) / (mx - mn)) * 100;
          li.style.left = a.toFixed(2) + '%';
          li.style.width = (z - a).toFixed(2) + '%';
        });
      }
      function update() {
        placeBands();
        var w = parseFloat(range.value);
        kg = unitPref === 'lb' ? w / KG_LB : w;
        val.textContent = (unitPref === 'lb' ? w.toFixed(1).replace(/\.0$/, '') + ' lb' : w.toFixed(1) + ' kg');
        var pct = ((w - range.min) / (range.max - range.min)) * 100;
        f.style.setProperty('--w', pct.toFixed(2) + '%');
        size = null;
        var first = bands[0];
        var last = bands[bands.length - 1];
        if (kg < first.lo - 0.05) out.textContent = fill(T.under, { kg: first.kg });
        else if (kg > last.hi + 0.05) out.textContent = fill(T.over, { kg: last.kg });
        else {
          for (var i = 0; i < bands.length; i++) {
            if (kg <= bands[i].hi + 0.001) {
              size = bands[i];
              break;
            }
          }
          out.textContent = fill(T.fits, { s: size.s, kg: size.kg, lb: size.lb });
        }
        $$('[data-finder-band]', f).forEach(function (li) {
          li.classList.toggle('is-on', !!size && li.getAttribute('data-finder-band') === size.s);
        });
        f.classList.toggle('is-none', !size);
        if (use) {
          use.hidden = !size;
          use.classList.remove('is-done');
          if (size) useLabel.textContent = fill(T.use, { s: size.s });
        }
      }
      range.addEventListener('input', update);
      unitBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          setUnit(b.getAttribute('data-finder-unit'));
        });
      });
      if (use) {
        use.addEventListener('click', function () {
          if (!size) return;
          document.dispatchEvent(new CustomEvent('pp:size-all', { detail: { size: size.s } }));
          useLabel.textContent = fill(T.used, { s: size.s });
          use.classList.add('is-done');
        });
      }
      update();
    });
  }

  /* start the heavy, decorative work once the page is idle (the buy flow starts at once) */
  function idle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 1800 });
    else setTimeout(fn, 400);
  }

  function init() {
    reveals();
    nav();
    faq();
    dates();
    commerce();
    finder();
    wiggle();
    idle(function () {
      drift();
      snow();
      walk();
      story();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
